import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/DiscoverSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/EcosystemSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/LearningIsEverywhereSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/OrganizationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/components/TeachSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/components/Header.tsx");
